module.exports = __webpack_public_path__ + "static/media/feelLike.e45db2f6.svg";